/**
 * Default form data for the Demand Gen ad creation step.
 *
 * Lives in a sibling file rather than inside `DemandGenAdCreationStep.tsx`
 * because exporting a runtime value from a component file breaks Vite's
 * fast-refresh (`react-refresh/only-export-components`). Types stay with
 * the component since type-only exports don't trigger the rule.
 */
import type { DemandGenAdFormData } from './DemandGenAdCreationStep';

export const DEFAULT_DEMAND_GEN_AD_FORM_DATA: DemandGenAdFormData = {
  adType: 'MULTI_ASSET',
  adName: '',
  businessName: '',
  callToAction: 'LEARN_MORE',
  finalUrl: '',
  headlines: [''],
  descriptions: [''],
  landscapePending: [],
  squarePending: [],
  portraitPending: [],
  logoPending: [],
  videoIds: [],
  longHeadlines: [''],
  carouselCards: [
    { headline: '', pending: null, finalUrl: '' },
    { headline: '', pending: null, finalUrl: '' },
  ],
};
